import {newRequest} from '@/utils/request'

// 角色列表
export const list = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/querylist', params)

// 新增角色
export const roleAdd = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/add', params)

// 修改角色
export const roleUpdate = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/update', params)

// 角色详情
export const roleDetails = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/query', params)

// 禁用角色
export const isDisable = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/disable', params)

// 启用角色
export const isEnable = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/enable', params)

// 删除角色
export const roleDelete = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/delete', params)

// 根据平台获取权限
export const roleAuthByAppid = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/authority/querylist', params)

// 查询角色权限
export const roleAuthByid = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/queryAuthority', params)

//
export const authorize = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/role/authorize', params)

// 新增组
export const groupAdd = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/roleGroup/add', params)

// 修改组
export const groupUpdate = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/roleGroup/update', params)

// 删除组
export const groupDelete = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/roleGroup/delete', params)
